'use es6';

import { SLACK_CHANNEL } from 'reference-resolvers/constants/CacheKeys';
import { getSlackChannelsByIds, getSlackChannelsSearchPage, createGetSlackChannelsByIds, createGetSlackChannelsSearchPage } from 'reference-resolvers/api/SlackAPI';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
export const createSlackChannelReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: SLACK_CHANNEL,
  createFetchByIds: createGetSlackChannelsByIds,
  createFetchSearchPage: createGetSlackChannelsSearchPage,
  fetchByIds: getSlackChannelsByIds,
  fetchSearchPage: getSlackChannelsSearchPage
}, options));
export default createSlackChannelReferenceResolver();